import { IFeedAchievementItem, IFeedPostItem } from "@eagerdog/interfaces";
import { Config } from "@eagerdog/config";

/**
 * Permalink helpers (FEED_POST_DEEP_LINK_PRD). Every share channel and the
 * "Copy link" menu item use the canonical /p/:id so one post has one URL.
 * Posts prefer their short share code; older posts fall back to the id.
 */

export const postPath = (post: Pick<IFeedPostItem, "_id" | "handle">): string =>
    `/p/${post.handle || post._id}`;

export const achievementPath = (item: Pick<IFeedAchievementItem, "id">): string =>
    `/p/${item.id}`;

export const webOrigin = (): string =>
    (Config.web.REACT_APP_WEB_URL || window.location.origin).replace(/\/$/, "");

export const postShareUrl = (post: Pick<IFeedPostItem, "_id" | "handle">): string =>
    `${webOrigin()}${postPath(post)}`;
